import { Col, Row } from "@/components/customComponents";

import Pulse from "./Pulse";

const SORT_TAB_COUNT = 5;
const ROW_COUNT = 5;

const TableSkeleton = () => (
  <Col className="gap-4">
    <Row className="items-center justify-between">
      <Pulse className="h-5 w-28" />
      <Row className="gap-1">
        {Array.from({ length: SORT_TAB_COUNT }).map((slot, i) => (
          <Pulse key={i} className="h-7 w-14 rounded-full" />
        ))}
      </Row>
    </Row>
    <div className="overflow-hidden rounded-xl border border-default-200 dark:border-default-100">
      <div className="border-b border-default-200 bg-default-50 px-4 py-3 dark:border-default-100 dark:bg-default-50/50">
        <Pulse className="h-4 w-full" />
      </div>
      {Array.from({ length: ROW_COUNT }).map((slot, i) => (
        <Row key={i} className="items-center gap-3 border-b border-default-100 px-4 py-3">
          <Pulse className="h-4 w-6" />
          <Pulse className="h-9 w-9 rounded-lg" />
          <Col className="flex-1 gap-1">
            <Pulse className="h-4 w-32" />
            <Pulse className="h-3 w-20" />
          </Col>
          <Pulse className="h-4 w-12" />
          <Pulse className="hidden h-4 w-10 sm:block" />
          <Pulse className="hidden h-4 w-10 md:block" />
          <Pulse className="h-4 w-10" />
        </Row>
      ))}
    </div>
  </Col>
);

export default TableSkeleton;
